export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-xs font-semibold uppercase tracking-wider text-foreground/80 mb-2">
      {children}
    </div>
  );
}
